module.exports = __webpack_public_path__ + "080261093d9060f7343a76a6cf582e80.svg";